import { SetRoutes } from 'components';
import routes from './routes';

const CompanyCategoriesDocumentPages = () => {
    return (
        <>
            <SetRoutes routes={routes} />
        </>
    );
};

export default CompanyCategoriesDocumentPages;
